import React from "react";
import logo from "../assets/logo.png";

const sections = [
  {
    title: "Quick Links",
    links: [
      "About Us",
      "Volunteer",
      "Our Members",
      "Donate",
      "Taskforces",
      "Contact Us",
    ],
  },
];

const MailSvg = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1510_94)">
      <path
        d="M1.54688 12.6567V5.32251C1.54688 4.21794 2.44229 3.32251 3.54686 3.32251H12.8811C13.9856 3.32251 14.8811 4.21794 14.8811 5.32251V12.6567C14.8811 13.7613 13.9856 14.6567 12.8811 14.6567H3.54686C2.4423 14.6567 1.54688 13.7613 1.54688 12.6567Z"
        stroke="white"
      />
      <path
        d="M4.38672 6.41949L8.25769 8.48401L12.1287 6.41949"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1510_94">
        <rect
          width="16"
          height="17"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const PhoneSvg = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1510_103)">
      <path
        d="M11.2736 10.0858L8.90104 10.5454C7.29844 9.7412 6.30851 8.81741 5.73239 7.37741L6.17598 4.99847L5.33747 2.76941H4.04952C2.92197 2.76941 2.0346 3.70322 2.26797 4.80636C2.61736 6.45796 3.40172 8.79121 5.15628 10.5454C7.00251 12.3913 9.5333 13.3572 11.3241 13.8419C12.4747 14.1533 13.5099 13.2469 13.5099 12.0549V10.9378L11.2736 10.0858Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1510_103">
        <rect
          width="16"
          height="17"
          fill="white"
          transform="translate(0.220703 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const socialIcons = {
  twitter: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1510_126)">
        <g clip-path="url(#clip1_1510_126)">
          <path
            d="M5.98621 8.34137L2.37428 12.3999H1.62606L5.75863 7.75508L6.0352 7.44423L5.77979 7.11578L1.26562 1.31104H4.30041L7.12146 4.97874L7.48979 5.45762L7.89135 5.00623L11.1787 1.31104H11.9255L8.11003 5.59941L7.83496 5.90858L8.08727 6.23661L12.828 12.3999H9.89124L6.75438 8.3668L6.38558 7.89261L5.98621 8.34137ZM9.82761 11.9794L9.97775 12.1724H10.2223H11.3779H12.3932L11.7742 11.3676L4.31507 1.66922L4.16495 1.47405H3.91874H2.67869H1.65634L2.28403 2.28103L9.82761 11.9794Z"
            fill="#FAFAFA"
            stroke="#FAFAFA"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1510_126">
          <rect
            width="14"
            height="13"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
        <clipPath id="clip1_1510_126">
          <rect
            width="14"
            height="13"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  facebook: (
    <svg
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1510_131)">
        <g clip-path="url(#clip1_1510_131)">
          <path
            d="M5.35456 5.63696H8.55456L8.199 7.05918H5.35456V13.4592H3.93233V7.05918H1.08789V5.63696H3.93233V4.30576C3.93233 3.03785 4.0646 2.57776 4.31207 2.11411C4.55456 1.65602 4.92917 1.28141 5.38727 1.03891C5.85091 0.791446 6.311 0.65918 7.57891 0.65918C7.95011 0.65918 8.2758 0.694735 8.55456 0.765846V2.0814H7.57891C6.6374 2.0814 6.35082 2.13687 6.05856 2.29331C5.84238 2.40851 5.68167 2.56922 5.56647 2.7854C5.41002 3.07767 5.35456 3.36425 5.35456 4.30576V5.63696Z"
            fill="#FAFAFA"
            stroke="#FAFAFA"
            stroke-width="0.8"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1510_131">
          <rect width="10" height="14" fill="white" />
        </clipPath>
        <clipPath id="clip1_1510_131">
          <rect width="10" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  youtube: (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1510_136)">
        <g clip-path="url(#clip1_1510_136)">
          <path
            d="M12.0798 1.65707L12.0865 1.66401C12.1753 1.75365 12.268 1.95009 12.3394 2.19293C12.3716 2.30274 12.3944 2.40375 12.4091 2.47725C12.4163 2.51372 12.4214 2.54271 12.4246 2.56177L12.4279 2.58242L12.4284 2.58618L12.432 2.61701C12.4351 2.6444 12.4396 2.68512 12.4451 2.73726C12.4561 2.84158 12.4707 2.99129 12.4854 3.17112C12.5149 3.53212 12.544 4.00857 12.544 4.48057V5.40001C12.544 5.87321 12.5149 6.34967 12.4854 6.71031C12.4707 6.88998 12.4561 7.03945 12.4451 7.14356C12.4397 7.19559 12.4351 7.23622 12.432 7.26354L12.4284 7.29429L12.428 7.29788L12.4246 7.3188C12.4214 7.33786 12.4163 7.36685 12.4091 7.40332C12.3944 7.47682 12.3716 7.57784 12.3394 7.68763C12.268 7.93046 12.1753 8.12689 12.0865 8.21653L12.0798 8.22349C11.7974 8.52007 11.5115 8.55001 11.2597 8.57638C11.2339 8.57908 11.2085 8.58174 11.1835 8.58465C10.3536 8.64356 9.31215 8.67457 8.47151 8.69075C8.05038 8.69885 7.68176 8.70321 7.41849 8.70553C7.28688 8.7067 7.18167 8.70735 7.10947 8.70772L7.02677 8.70807L7.00555 8.70813L7.00025 8.70815L6.99522 8.70809L6.96896 8.70782L6.86805 8.70677C6.78057 8.70581 6.65443 8.70434 6.49999 8.70229C6.19106 8.69819 5.76925 8.69178 5.31749 8.68248C4.41901 8.66398 3.42928 8.63452 2.95839 8.59157C2.87769 8.5768 2.79904 8.56633 2.7223 8.5561C2.42841 8.51692 2.16258 8.48148 1.91689 8.22347L1.91127 8.21768C1.82309 8.12803 1.73072 7.9313 1.65953 7.68816C1.62735 7.57824 1.60462 7.47713 1.59001 7.40356C1.58276 7.36704 1.57765 7.33803 1.57446 7.31893L1.57114 7.29823L1.57067 7.29438L1.56709 7.26355C1.56396 7.23616 1.55942 7.19545 1.55395 7.14331C1.54299 7.03899 1.52832 6.88929 1.51363 6.70944C1.48413 6.34845 1.45508 5.87201 1.45508 5.40001V4.48057C1.45508 4.00893 1.48468 3.53277 1.51474 3.17192C1.52971 2.99218 1.54467 2.84254 1.55583 2.73828C1.56141 2.68618 1.56603 2.64549 1.56922 2.61812L1.57287 2.58733L1.57346 2.58245L1.57367 2.58104L1.57693 2.56043C1.58006 2.54139 1.58509 2.51242 1.59224 2.47598C1.60667 2.40253 1.62917 2.3016 1.66116 2.19188C1.73195 1.94915 1.82417 1.75325 1.9125 1.66402L1.91923 1.65709C2.2017 1.3605 2.48762 1.33056 2.73937 1.3042C2.76525 1.30149 2.79077 1.29882 2.81589 1.2959C3.64526 1.23585 4.68578 1.20542 5.52585 1.19012C5.94658 1.18246 6.31482 1.17863 6.57779 1.17672C6.70926 1.17576 6.81434 1.17528 6.88645 1.17504L6.96903 1.17483L6.99021 1.17481H6.99551L6.99679 1.1748H7.00188L7.00354 1.17481H7.00883L7.03001 1.17483L7.11259 1.17504C7.1847 1.17528 7.28979 1.17576 7.42125 1.17672C7.68423 1.17863 8.05247 1.18246 8.47321 1.19012C9.31329 1.20542 10.3538 1.23585 11.1832 1.2959C11.2083 1.29882 11.2338 1.30149 11.2597 1.3042C11.5114 1.33057 11.7974 1.36051 12.0798 1.65707ZM5.2505 6.51614V7.33995L5.98129 6.95969L9.24667 5.26061L10.0961 4.8186L9.24793 4.37418L5.98255 2.66324L5.2505 2.27967V3.10613V6.51614Z"
            fill="#FAFAFA"
            stroke="#FAFAFA"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1510_136">
          <rect width="14" height="10" fill="white" />
        </clipPath>
        <clipPath id="clip1_1510_136">
          <rect width="14" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  instagram: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1510_141)">
        <g clip-path="url(#clip1_1510_141)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.78181 2.98007C9.65354 3.06577 9.55353 3.18759 9.49451 3.33011C9.44654 3.44596 9.42737 3.57125 9.43802 3.69535C9.44047 3.72393 9.44451 3.75245 9.45014 3.78078C9.48021 3.93208 9.55448 4.07107 9.6636 4.18016C9.77264 4.28897 9.91186 4.36357 10.063 4.39362C10.0918 4.39935 10.1208 4.40343 10.1499 4.40587C10.2735 4.41625 10.3983 4.39703 10.5137 4.34923C10.6562 4.2902 10.778 4.19023 10.8637 4.06195C10.9031 4.00294 10.9341 3.93916 10.9561 3.87246C10.9818 3.79419 10.9952 3.7119 10.9952 3.62861C10.9952 3.61614 10.9949 3.60371 10.9943 3.59131C10.9939 3.58236 10.9933 3.57342 10.9925 3.56451C10.9787 3.39697 10.9111 3.23815 10.7996 3.11199C10.789 3.10005 10.7781 3.0884 10.7667 3.07706C10.7644 3.07469 10.762 3.07234 10.7596 3.07001C10.6232 2.93713 10.4432 2.85893 10.2537 2.84956C10.2521 2.84948 10.2505 2.84941 10.2489 2.84934C10.2377 2.84885 10.2265 2.84861 10.2152 2.84861C10.1279 2.84861 10.0418 2.86324 9.96022 2.89144C9.89754 2.91312 9.83755 2.94282 9.78181 2.98007ZM9.95642 1.86751C10.0433 1.88335 10.1296 1.90235 10.2152 1.92447C10.3293 1.95398 10.4421 1.98905 10.5532 2.02961C10.8413 2.13656 11.1007 2.30881 11.311 2.53272C11.3162 2.53831 11.3215 2.54395 11.3267 2.54961C11.5397 2.74927 11.7061 2.99339 11.8142 3.26461C11.8578 3.3841 11.8951 3.50561 11.9259 3.62861C11.9461 3.70951 11.9636 3.79105 11.9783 3.8731C12.0152 4.07952 12.0343 4.28913 12.0352 4.49961C12.0677 5.14961 12.0742 5.39011 12.0742 7.09961C12.0742 8.80911 12.0677 9.04961 12.0352 9.69961C12.0304 10.1122 11.9557 10.521 11.8142 10.9086C11.7103 11.1915 11.5437 11.4471 11.3267 11.6561C11.1158 11.871 10.8608 12.0373 10.5792 12.1436C10.1916 12.2851 9.78276 12.3598 9.37014 12.3646C8.72014 12.3971 8.47964 12.4036 6.77014 12.4036C5.06064 12.4036 4.82014 12.4036 4.17014 12.3646C3.74173 12.3727 3.31513 12.3066 2.90914 12.1696C2.63991 12.0579 2.39653 11.8919 2.19414 11.6821C1.97841 11.4733 1.81379 11.2175 1.71314 10.9346C1.55445 10.5415 1.46643 10.1234 1.45314 9.69961C1.45314 9.45168 1.44747 9.26333 1.44045 9.03031C1.42907 8.65242 1.41414 8.15706 1.41414 7.09961C1.41414 5.39012 1.41414 5.14961 1.45314 4.49961C1.45606 4.07779 1.53306 3.65977 1.68064 3.26461C1.79508 2.99025 1.97072 2.74568 2.19414 2.54961C2.39162 2.32612 2.63569 2.14862 2.90914 2.02961C3.30535 1.88664 3.72294 1.81191 4.14414 1.80861C4.39207 1.80861 4.58042 1.80294 4.81344 1.79592C5.19133 1.78453 5.6867 1.76961 6.74414 1.76961C8.45363 1.76961 8.69415 1.76961 9.34414 1.80861C9.54991 1.81097 9.75472 1.83073 9.95642 1.86751ZM12.9062 11.3571C12.7426 11.7914 12.4851 12.1843 12.1522 12.5076C11.8303 12.8408 11.4369 13.0964 11.0017 13.2551C10.4964 13.4461 9.96216 13.5494 9.42214 13.5606C8.73314 13.5996 8.51214 13.5996 6.74414 13.5996C4.97614 13.5996 4.75514 13.5996 4.06614 13.5606C3.52609 13.5494 2.99192 13.4461 2.48664 13.2551C2.05224 13.0948 1.65915 12.8394 1.33614 12.5076C1.00297 12.1857 0.747354 11.7923 0.588641 11.3571C0.397646 10.8518 0.294327 10.3176 0.283141 9.77761C0.244141 9.08861 0.244141 8.86761 0.244141 7.09961C0.244141 5.33161 0.244141 5.11061 0.283141 4.42161C0.294327 3.88155 0.397646 3.34738 0.588641 2.84211C0.747354 2.4069 1.00297 2.01347 1.33614 1.69161C1.65915 1.35982 2.05224 1.10443 2.48664 0.944109C2.99192 0.753114 3.52609 0.649795 4.06614 0.638609C4.75514 0.599609 4.97614 0.599609 6.74414 0.599609C8.51214 0.599609 8.73314 0.599609 9.42214 0.638609C9.96216 0.649795 10.4964 0.753114 11.0017 0.944109C11.4369 1.10282 11.8303 1.35844 12.1522 1.69161C12.4837 2.01614 12.7409 2.40865 12.9062 2.84211C13.0916 3.34872 13.1925 3.8823 13.2052 4.42161C13.2442 5.11061 13.2442 5.33161 13.2442 7.09961C13.2442 8.1881 13.2294 8.69022 13.218 9.07618C13.2109 9.31712 13.2052 9.5128 13.2052 9.77761C13.1925 10.3169 13.0916 10.8505 12.9062 11.3571ZM4.3951 9.45972C3.9285 8.99406 3.61041 8.40051 3.48101 7.75412C3.35161 7.10771 3.41672 6.43746 3.66811 5.82804C3.91949 5.21864 4.34587 4.69741 4.89337 4.33023C5.44087 3.96305 6.08492 3.76639 6.74414 3.76511C7.18283 3.76339 7.61751 3.84843 8.02321 4.01532C8.21318 4.09346 8.39502 4.18882 8.56659 4.29996C8.76108 4.42595 8.94236 4.57222 9.10725 4.73664C9.10724 4.73663 9.10725 4.73665 9.10725 4.73664C9.10754 4.73693 9.10786 4.73725 9.10815 4.73754C9.27329 4.90239 9.42025 5.08374 9.54688 5.27841C9.6583 5.4497 9.75397 5.6313 9.83243 5.82103C10.0001 6.22641 10.086 6.66093 10.0852 7.09961C10.0852 7.75883 9.88971 8.40327 9.52363 8.9515C9.15755 9.49967 8.63712 9.92711 8.0282 10.1797C7.41928 10.4322 6.74915 10.4987 6.1025 10.3705C5.45585 10.2424 4.86169 9.92546 4.3951 9.45972ZM10.3707 3.47297C10.3706 3.47293 10.3707 3.473 10.3707 3.47297V3.47297ZM10.3707 3.47297L10.2152 3.62847L10.4185 3.71269C10.4296 3.68586 10.4352 3.65728 10.4352 3.62861C10.4352 3.6143 10.4338 3.59998 10.431 3.58583C10.4225 3.54315 10.4014 3.50379 10.3707 3.47297ZM10.2152 3.62847L10.4185 3.71269C10.4129 3.72611 10.4061 3.73889 10.3981 3.75082C10.3821 3.77477 10.3615 3.79543 10.3374 3.81151C10.3254 3.81956 10.3127 3.82636 10.2994 3.83185C10.2994 3.83183 10.2994 3.83186 10.2994 3.83185C10.2729 3.84283 10.2442 3.84861 10.2152 3.84861C10.2006 3.84861 10.1863 3.84717 10.1722 3.84438L10.2152 3.62847ZM10.0596 3.78412C10.0595 3.7841 10.0596 3.78415 10.0596 3.78412V3.78412ZM10.2152 3.62847L10.0596 3.78412C10.0905 3.81506 10.1299 3.83595 10.1722 3.84438L10.2152 3.62847ZM10.0596 3.78412L10.2152 3.62847L10.0119 3.54437C10.0009 3.57093 9.99514 3.59954 9.99514 3.62861C9.99514 3.64315 9.99659 3.65755 9.99939 3.67161C10.0079 3.71388 10.0286 3.75314 10.0596 3.78412ZM10.0119 3.54437L10.2152 3.62847L10.258 3.41283C10.2439 3.41001 10.2295 3.40861 10.2152 3.40861C10.1865 3.40861 10.1579 3.41421 10.1311 3.42532C10.131 3.42535 10.1311 3.42529 10.1311 3.42532C10.1177 3.43085 10.1049 3.43774 10.093 3.44567C10.069 3.46168 10.0483 3.4823 10.0322 3.50637M10.2152 3.62847L10.258 3.41283C10.3008 3.42134 10.3401 3.44239 10.3707 3.47297L10.2152 3.62847ZM10.0119 3.54437C10.0174 3.53113 10.0242 3.51839 10.0322 3.50637L10.0119 3.54437ZM5.54161 8.89933C5.89757 9.13714 6.31605 9.26411 6.74414 9.26411C7.02839 9.26411 7.30985 9.20812 7.57246 9.09936C7.83507 8.99059 8.07369 8.83113 8.27468 8.63014C8.47567 8.42915 8.63512 8.19054 8.74389 7.92793C8.85266 7.66532 8.90864 7.38386 8.90864 7.09961C8.90864 6.67151 8.78168 6.25303 8.54386 5.89707C8.30603 5.54113 7.96797 5.2637 7.57246 5.09987C7.17695 4.93605 6.74174 4.89318 6.32187 4.9767C5.902 5.06022 5.51632 5.26637 5.21361 5.56908C4.9109 5.87179 4.70476 6.25746 4.62124 6.67733C4.53771 7.09721 4.58058 7.53241 4.74441 7.92793C4.90823 8.32344 5.18566 8.66149 5.54161 8.89933Z"
            fill="#FAFAFA"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1510_141">
          <rect width="14" height="14" fill="white" />
        </clipPath>
        <clipPath id="clip1_1510_141">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};

const ContactItem = ({ SvgComponent, label, value, href }) => (
  <div className="flex flex-col w-full mb-2">
    <div className="flex items-center mb-1">
      <div className="mr-2">{SvgComponent}</div>
      <p className="font-primary">{label}:</p>
    </div>
    <div className="border-t border-gray-400 opacity-50 w-full mb-2"></div>
    <a
      href={href}
      className="text-gray-400 font-primary text-sm leading-5 text-left"
    >
      {value}
    </a>
  </div>
);

const socialLinks = [
  { href: "https://x.com/i/flow/login?redirect_after_login=%2FFaithCoalition", icon: socialIcons.twitter },
  { href: "https://www.facebook.com/fcftcg/", icon: socialIcons.facebook },
  { href: "https://www.instagram.com/faithcoalition", icon: socialIcons.instagram },
];

const Footer = () => {
  return (
    <footer className="bg-custom-blue text-white py-12">
      <div className="container mx-auto px-4 lg:px-0">
        <div className="flex flex-wrap">
          <div className="w-full md:w-1/4 mb-6 md:mb-0">
            <img
              src={logo}
              alt="Logo"
              className="mb-4"
              style={{ width: "60px", height: "60px" }}
            />
            <div
              className="text-gray-400 font-primary"
              style={{ fontSize: "14px" }}
            >
              <p>2208 E. Kansas</p>
              <p>Springfield, IL 62703</p>
            </div>
            <div
              className="flex flex-col md:flex-row mt-4 space-y-2 md:space-y-0 md:space-x-8"
              style={{ fontSize: "14px" }}
            >
              <ContactItem
                SvgComponent={<MailSvg />}
                label="Email"
                value="info@faithcoalition-il.org"
                href="mailto:info@faithcoalition-il.org"
              />
              <ContactItem
                SvgComponent={<PhoneSvg />}
                label="Phone"
                value="217-544-2297"
                href="tel:+42175442434"
              />
            </div>
          </div>
          <div className="w-full md:w-2/4 flex flex-wrap md:flex-row md:ml-[216.56px]">
            {sections.map((section, index) => (
              <div
                key={index}
                className="w-full md:w-auto mb-4 md:mb-0 md:px-3"
              >
                <h3
                  className="font-primary mb-2"
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    textAlign: "left",
                  }}
                >
                  {section.title}
                </h3>
                <ul
                  className="font-primary grid grid-cols-2 gap-x-6 gap-y-4"
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                  }}
                >
                  {section.links.map((link, index) => (
                    <li key={index}>
                      <a
                        href={`/${link.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-gray-400"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div className="w-full md:w-auto flex flex-col  md:items-start mt-4 md:mt-0 md:ml-[70px]">
              <div
                className="font-primary mb-2"
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#FFFFFF",
                }}
              >
                Connect with Us
              </div>
              <div className="flex gap-3">
                {socialLinks.map(({ href, icon }, index) => (
                  <a
                    key={index}
                    href={href}
                    className="flex items-center justify-center w-8 h-8 rounded-full bg-opacity-10"
                    style={{ background: "rgba(255, 255, 255, 0.04)" }}
                  >
                    {icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div
          className="border-t border-gray-400 opacity-30 my-4"
          style={{ borderColor: "rgba(227, 227, 227, 1)" }}
        ></div>
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <div className="flex space-x-4 mt-2 md:mt-0 order-2 md:order-1">
            <a
              href="/privacy-policy"
              className="text-gray-400 hover:text-white font-primary"
              style={{ fontSize: "14px" }}
            >
              Privacy Policy
            </a>
            <a
              href="/terms-conditions"
              className="text-gray-400 hover:text-white font-primary"
              style={{ fontSize: "14px" }}
            >
              Terms & Conditions
            </a>
          </div>
          <div className="text-gray-400 text-sm text-center flex-1 order-1 md:order-2 mt-4 md:mt-0">
            Copyright &copy; 2024 • All Rights Reserved
          </div>
          <div className="order-3 mt-2 md:mt-0">
            <a
              href="#"
              className="text-gray-400 hover:text-white font-primary flex items-center"
              style={{ fontSize: "14px" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="w-5 h-5"
              >
                <path
                  fillRule="evenodd"
                  d="M9.47 6.47a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 8.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06l4.25-4.25Z"
                  clipRule="evenodd"
                />
              </svg>
              Back to Top
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default React.memo(Footer);